/* HugPet — shared front-end (prototype). Cart persists across pages via localStorage. */
(function () {
  "use strict";

  var PRODUCTS = {
    ball: { url: "/products/durable-rope-tug-ball" },
    nail: { url: "/products/led-pet-nail-care-kit" }
  };

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var fmt = function (n) { return "$" + n.toFixed(2); };

  /* ---------- cart state (key -> qty) ---------- */
  var KEY = "hugpet_cart";
  var cart = {};
  try { cart = JSON.parse(localStorage.getItem(KEY) || "{}") || {}; } catch (e) { cart = {}; }
  function save() { try { localStorage.setItem(KEY, JSON.stringify(cart)); } catch (e) {} }

  function count() { var c = 0; for (var k in cart) c += cart[k]; return c; }
  function total() { var t = 0; for (var k in cart) { if (PRODUCTS[k]) t += PRODUCTS[k].price * cart[k]; } return t; }

  function setQty(key, qty) {
    qty = Math.max(0, qty | 0);
    if (qty === 0) { delete cart[key]; } else { cart[key] = qty; }
    save(); renderCart();
  }
  function add(key) {
    if (PRODUCTS[key]) location.href = PRODUCTS[key].url;
  }

  /* ---------- cart drawer rendering (safe DOM) ---------- */
  var emptyEl;
  function buildItem(key) {
    var p = PRODUCTS[key], q = cart[key];
    var it = document.createElement("div"); it.className = "cart-item";
    var im = document.createElement("img"); im.src = p.img; im.alt = ""; it.appendChild(im);
    var t = document.createElement("div"); t.className = "ci-t";
    var nm = document.createElement("b"); nm.textContent = p.name; t.appendChild(nm);
    var line = document.createElement("div"); line.className = "ci-line"; line.textContent = fmt(p.price * q); t.appendChild(line);
    var st = document.createElement("div"); st.className = "stepper";
    var minus = document.createElement("button"); minus.type = "button"; minus.setAttribute("aria-label", "Decrease"); minus.textContent = "−";
    minus.addEventListener("click", function () { setQty(key, q - 1); });
    var qn = document.createElement("span"); qn.textContent = q;
    var plus = document.createElement("button"); plus.type = "button"; plus.setAttribute("aria-label", "Increase"); plus.textContent = "+";
    plus.addEventListener("click", function () { setQty(key, q + 1); });
    st.appendChild(minus); st.appendChild(qn); st.appendChild(plus); t.appendChild(st);
    it.appendChild(t);
    return it;
  }
  function renderCart() {
    var cc = $("#cartCount");
    if (cc) { cc.textContent = count(); cc.classList.toggle("show", count() > 0); }
    var ct = $("#cartTotal"); if (ct) ct.textContent = fmt(total());
    var body = $("#cartBody"); if (!body) return;
    body.replaceChildren();
    var keys = Object.keys(cart);
    if (!keys.length) { if (emptyEl) body.appendChild(emptyEl); return; }
    keys.forEach(function (k) { if (PRODUCTS[k]) body.appendChild(buildItem(k)); });
  }
  function openCart() { var d = $("#drawer"), s = $("#scrim"); if (d) d.classList.add("show"); if (s) s.classList.add("show"); }
  function closeCart() { var d = $("#drawer"), s = $("#scrim"); if (d) d.classList.remove("show"); if (s) s.classList.remove("show"); }

  /* ---------- wire up after DOM ready ---------- */
  function readQty() {
    var qi = $("#qtyInput");
    if (!qi) return 1;
    var v = parseInt(qi.value, 10);
    return (isNaN(v) || v < 1) ? 1 : v;
  }
  /* Only the main PDP buy box reads the quantity selector; every other
     buy/add button (cross-sell, homepage cards, mobile bar) adds 1. */
  function qtyFor(btn) { return btn.closest(".pdp-actions") ? readQty() : 1; }

  document.addEventListener("DOMContentLoaded", function () {
    emptyEl = $("#cartEmpty");
    renderCart();

    $$("[data-add]").forEach(function (b) { b.addEventListener("click", function () { add(b.getAttribute("data-add"), qtyFor(b)); }); });
    $$("[data-buy]").forEach(function (b) { b.addEventListener("click", function () { add(b.getAttribute("data-buy"), qtyFor(b)); }); });
    var cb = $("#cartBtn"); if (cb) cb.addEventListener("click", function () { location.href = "/cart"; });
    var cl = $("#closeCart"); if (cl) cl.addEventListener("click", closeCart);
    var sc = $("#scrim"); if (sc) sc.addEventListener("click", closeCart);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeCart(); });

    var bg = $("#burger");
    if (bg) bg.addEventListener("click", function () {
      var p = $("#products");
      if (p) p.scrollIntoView({ behavior: "smooth" });
      else location.href = "index.html#products";
    });

    /* qty selector on PDP */
    var qb = $(".qty-box");
    if (qb) {
      var input = $("#qtyInput", qb);
      $$("button[data-step]", qb).forEach(function (b) {
        b.addEventListener("click", function () {
          var v = parseInt(input.value, 10) || 1;
          v += parseInt(b.getAttribute("data-step"), 10);
          input.value = Math.max(1, v);
        });
      });
    }

    /* gallery thumbnails (PDP) */
    var main = $("#galleryMain");
    if (main) {
      $$(".gallery-thumbs button").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var src = btn.getAttribute("data-img");
          if (src) main.src = src;
          $$(".gallery-thumbs button").forEach(function (x) { x.classList.remove("active"); });
          btn.classList.add("active");
        });
      });
    }

    /* header shadow + sticky mobile bar */
    var hdr = $("#hdr"), mbar = $("#mbar");
    window.addEventListener("scroll", function () {
      if (hdr) hdr.classList.toggle("scrolled", window.scrollY > 12);
      if (mbar) mbar.classList.toggle("show", window.scrollY > 700);
    });

    /* reveal on scroll */
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
      }, { threshold: .12 });
      $$(".reveal").forEach(function (el) { io.observe(el); });

      /* play videos only while visible */
      var vio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { var v = e.target; if (e.isIntersecting) { v.play().catch(function () {}); } else { v.pause(); } });
      }, { threshold: .35 });
      $$("video").forEach(function (v) { vio.observe(v); });
    } else {
      $$(".reveal").forEach(function (el) { el.classList.add("in"); });
    }

    /* sound toggle */
    $$(".sound-btn").forEach(function (b) {
      b.addEventListener("click", function () {
        var v = $("#" + b.getAttribute("data-sound"));
        if (!v) return;
        v.muted = !v.muted;
        b.style.background = v.muted ? "" : "var(--o-deep)";
        if (!v.muted) v.play().catch(function () {});
      });
    });
  });
})();
